import { GetRelevantProductsOutputParser } from "@redotech/redo-concierge-conversation-common/product-details-db-parser";
import { ContentType } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import { literal } from "zod";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";

/**
 * This is the message type for the response to the tool call to get relevant
 * products.
 */
export const RelevantProductsMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.TOOL_CALL_RELEVANT_PRODUCTS),
  structuredContent: GetRelevantProductsOutputParser.optional(),
});

export const RelevantProductsMessageDbParser =
  RelevantProductsMessageSchema.merge(AutoGeneratedFieldsSchema);
